import { useSessionValue } from '@portal/appLayer/auth';
import { useStoreValue } from './useStore';
import { useEffect } from 'react';
import { timeSpentEvent } from '@portal/analytics/events';

export const useTimeSpent = () => {
  const session = useSessionValue()
  const store = useStoreValue();

  useEffect(() => {
    const timer = setTimeout(
      () => timeSpentEvent({
        eventId: Date.now().toString(),
        user: {
          email: session?.customer.email || '',
        },
        store
      }),
      30000 // 30 sec
    );

    return () => {
      clearTimeout(timer);
    };
  }, [session?.customer.email, store]);

  return;
};
